import React, { useState, useEffect } from "react";
import { experimentalStyled, Container, useMediaQuery } from "@mui/material";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import MiniDrawer from "../components/Drawer/drawer";
import Header from "./MainLayout/Header/header";
import Footer from "./MainLayout/Footer/footer";

const PageWrapper = experimentalStyled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden",
}));

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  //Define const to hide header and footer
  const [hideHeaderFooter, setHideHeaderFooter] = useState(false);
  // State to control visibility of the smaller header
  const [showSmallHeader, setShowSmallHeader] = useState(false);
  //Define const to hide footer
  const [hideFooter, setHideFooter] = useState(false);
  // Define the breakpoint for 640px
  const isLargeScreen = useMediaQuery("(min-width:640px)");

  const { eventId } = useParams(); // Get the event ID from URL

  const memberId = localStorage.getItem("memberId");

  // Check the current route to hide header and footer
  useEffect(() => {
    if (
      location.pathname === "/welcome" ||
      location.pathname === "/login" ||
      location.pathname === "/first_time_login" ||
      location.pathname === "/forgot_password" ||
      location.pathname === "/retrieve_email" ||
      location.pathname === "/membership_selection" ||
      location.pathname === "/password_authentication" ||
      location.pathname === "/set_new_password" ||
      location.pathname === "/otp" ||
      location.pathname === "/first_time_otp"
    ) {
      setHideHeaderFooter(true);
    } else {
      setHideHeaderFooter(false);
    }
  }, [location]);

  // Check the current route to hide footer
  useEffect(() => {
    if (
      location.pathname === "/dashboard" ||
      location.pathname === "/my_event" ||
      location.pathname === "/discover_event" ||
      location.pathname === "/gallery" ||
      location.pathname === "/document"
    ) {
      setHideFooter(false);
    } else {
      setHideFooter(true);
    }
  }, [location]);

  // useEffect(() => {
  //   if (
  //     location.pathname === "/profile" ||
  //     location.pathname === "/notification" ||
  //     location.pathname === "/edit_profile" ||
  //     location.pathname === "/change_password" ||
  //     location.pathname === "/membership_renewal" ||
  //     location.pathname === "/secondary_account" ||
  //     location.pathname === "/my_event" ||
  //     location.pathname === "/discover_event" ||
  //     location.pathname === "/gallery" ||
  //     location.pathname === "/document" ||
  //     location.pathname === "/event_details/" ||
  //     location.pathname === "/view_event" ||
  //     location.pathname === "/event_payment"
  //   ) {
  //     setShowSmallHeader(true);
  //   } else {
  //     setShowSmallHeader(false);
  //   }
  // }, [location]);
  useEffect(() => {
    const smallHeaderPaths = [
      "/profile",
      "/notification",
      "/edit_profile",
      "/change_password",
      "/reset_pin",
      "/membership_renewal",
      "/secondary_account",
      "/my_event",
      "/discover_event",
      "/gallery",
      "/document",
      "/view_event",
      "/event_payment",
    ];

    // Include paths that match "/event_details/{eventId}"
    const isEventDetails = location.pathname.startsWith("/event_details");

    if (smallHeaderPaths.includes(location.pathname) || isEventDetails) {
      setShowSmallHeader(true);
    } else {
      setShowSmallHeader(false);
    }
  }, [location]);

  return (
    <PageWrapper>
      {!hideHeaderFooter && !isLargeScreen && <Header />}
      {/* Conditionally render Sidebar */}
      {isLargeScreen && !hideHeaderFooter && <MiniDrawer />}
      <Container
        maxWidth={false}
        sx={{
          marginTop:
            hideHeaderFooter && isLargeScreen
              ? "0px" // Set marginTop to 0px if both header/footer are hidden and it's a large screen
              : showSmallHeader || isLargeScreen
              ? "110px" // Set marginTop to 110px when showSmallHeader is true or on large screens
              : !hideHeaderFooter
              ? !hideFooter
                ? "180px"
                : "100px"
              : "0px", // Default to 0px if none of the conditions match
        }}
        disableGutters
      >
        <Outlet />
      </Container>
      {!hideHeaderFooter && !isLargeScreen && !hideFooter && <Footer />}
    </PageWrapper>
  );
  // }
};

export default MainLayout;
